<template>
  <div>
    <a-form-model
        layout="vertical"
        :model="addForm"
        ref="addForm"
        :rules="addFormRules"
    >
      <!-- 基本信息 -->
      <a-row class="time-row">
        <header>
          <h3>基本信息</h3>
        </header>
        <a-col :span="5"  >
          <a-form-model-item prop="id" v-show="false">
            <a-input  v-model="addForm.id" placeholder="请输入触发器名称" />
          </a-form-model-item>
          <a-form-model-item label="触发器名称" prop="name">
            <a-input  v-model="addForm.name" placeholder="请输入触发器名称" />
          </a-form-model-item>
        </a-col >
        <a-col :span="5"  >
          <a-form-model-item label="选择部门" prop="orgId" >
            <a-tree-select
                :disabled="editDisabled"
                v-model='addForm.orgId'
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :tree-data="treeData"
                placeholder="选择部门"
                @change="treeChange"
                show-search
                :filterTreeNode="filter_tree_node"
                tree-default-expand-all
                :replaceFields="{ title: 'name', key: 'id',value:'id' }"
            >
            </a-tree-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="5"v-if="addForm.orgId" >
          <a-form-model-item label="选择流程" prop="processId"  style="position:relative;">
            <a-select
                v-model="addForm.processId"
                :disabled="editDisabled"
                placeholder="请选择"
                @change="taskChange"
                show-search
                :filter-option="filterOption"
            >
              <a-select-option
                  :key="item.id"
                  v-for="item in this.taskList"
                  :value="item.id"
                  :label="item.name"
              >{{ item.name }}</a-select-option
              >
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="5" style="margin-right: 0.4%;">
          <a-form-model-item label="作业优先级" prop="priority">
            <a-select v-model="addForm.priority" placeholder="请选择">
              <a-select-option
                  v-for="(v, index) in priorityName"
                  :key="index"
                  :value="Number(index)"
              >
                <img :src="priorityIcon[index]" style="margin-top: -5px" />
                {{ v }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col >
        <a-col :span="5">
          <a-form-model-item label="是否录屏" prop="screenRecord"  >
            <a-switch v-model="addForm.screenRecord"  checked-children="开" un-checked-children="关"   />

          </a-form-model-item>
        </a-col>




        <!--    <a-col :span="24">-->
        <!--      <a-tabs default-active-key="1" >-->
        <!--        <a-tab-pane key="1" tab="执行设备" >-->
        <!--          <a-col :span="24" >-->
        <!--              <a-form-model-item-->
        <!--                prop="executeType"-->
        <!--                class="group-wrapper"-->
        <!--                style="border-bottom: 1px solid #d2d2d2;margin:5px 0 15px;padding-bottom: 15px;"-->
        <!--              >-->
        <!--                <a-radio-group v-model="addForm.executeType" style="display:flex;justify-content: flex-start;">-->
        <!--                  <a-radio :value="1"> 特定机器人 </a-radio>-->
        <!--                  <a-radio :value="2"> 动态分配 </a-radio>-->
        <!--                </a-radio-group>-->
        <!--              </a-form-model-item>-->
        <!--            </a-col>-->
        <!--            <a-col  :span="12" v-if="addForm.executeType == 2">-->
        <!--              <a-form-model-item label="执行流程次数" prop="executeCount">-->
        <!--                <a-input-number-->
        <!--                  placeholder="请输入"-->
        <!--                  style="width: 100%"-->
        <!--                  v-model="addForm.executeCount"-->
        <!--                  :min="1"-->
        <!--                  :max="999"-->
        <!--                />-->
        <!--              </a-form-model-item>-->
        <!--            </a-col>-->
        <!--            <a-col :span="24" v-if="addForm.executeType == 1">-->
        <!--              <a-table-->
        <!--                :columns="robotColumns"-->
        <!--                :data-source="robotData"-->
        <!--                :pagination="false"-->
        <!--                @change="robotTableChange"-->
        <!--                :loading="btnLoad"-->
        <!--                width="400px"-->
        <!--                rowKey="id"-->
        <!--                :rowSelection="{-->
        <!--                  selectedRowKeys: selectedRowKeys,-->
        <!--                  onChange: onSelectChange,-->
        <!--                }"-->
        <!--                :scroll="{ y: 200 }"-->
        <!--                style="margin-bottom:20px;"-->
        <!--              >-->
        <!--                <template slot="name" slot-scope="text, record">-->
        <!--                  <img :src="statsIcon[record.status]" />-->
        <!--                  <span> {{ text }}</span>-->
        <!--                </template>-->
        <!--                <template slot="status" slot-scope="text">-->
        <!--                  <span> {{ statusName[text] }}</span>-->
        <!--                </template>-->
        <!--              </a-table>-->
        <!--            </a-col>-->
        <!--        </a-tab-pane>-->
        <!--        <a-tab-pane key="2" tab="附加参数" force-render>-->
        <!--          <a-col-->
        <!--            :span="24"-->
        <!--          >-->
        <!--            <a-table-->
        <!--              :columns="parameterColumns"-->
        <!--              :data-source="addForm.parameter"-->
        <!--              :loading="btnLoad"-->
        <!--              :pagination="false"-->
        <!--              :scroll="{ y: 220 }"-->
        <!--            >-->
        <!--              <template slot="argName" slot-scope="text">-->
        <!--                <span>{{ text }}</span>-->
        <!--              </template>-->
        <!--              <template slot="defaultValue" slot-scope="text, record, index">-->
        <!--                <a-form-model-item :prop="'parameter.' + index + '.defaultValue'">-->
        <!--                  <a-input-number-->
        <!--                    v-model="record.defaultValue"-->
        <!--                    placeholder="请输入"-->
        <!--                    :min="1"-->
        <!--                    :max="999"-->
        <!--                    v-if="record.argType === 1"-->
        <!--                    style="width: 100%"-->
        <!--                  />-->
        <!--                  <a-input-->
        <!--                    v-model="record.defaultValue"-->
        <!--                    placeholder="请输入"-->
        <!--                    -->
        <!--                    v-if="record.argType === 2 || record.argType === 4"-->
        <!--                  >-->
        <!--                  <a-icon  slot="suffix" type="edit" style="color: rgba(0,0,0,.45)" />-->
        <!--                  </a-input>-->
        <!--                  <a-select-->
        <!--                    v-model="record.defaultValue"-->
        <!--                    placeholder="请输入"-->
        <!--                    v-if="record.argType === 3"-->
        <!--                  >-->
        <!--                    <a-select-option value="true">是</a-select-option>-->
        <!--                    <a-select-option value="false">否</a-select-option>-->
        <!--                  </a-select>-->
        <!--                </a-form-model-item>-->
        <!--              </template>-->
        <!--            </a-table>-->
        <!--          </a-col> -->
        <!--        </a-tab-pane>-->
        <!--      </a-tabs>-->
        <!--    </a-col>-->
      </a-row>

      <!-- 触发设置 -->
      <a-row class="time-row" style="margin-top: 20px">
        <header>
          <h3>触发设置</h3>
        </header>
        <a-divider orientation="left">
          邮箱配置
        </a-divider>
        <a-col :span="5"  >
          <a-form-model-item label="服务器(协议)类型" prop="extra.emailSchedule.emailServerType"
                             :rules="[
                {
                  required: true,
                  message: '服务器(协议)类不能为空',
                  trigger: 'blur'
                },
              ]"
          >
            <a-select
                v-model="addForm.extra.emailSchedule.emailServerType"
                placeholder="请选择"
                show-search
            >
              <a-select-option :value="0">POP3</a-select-option>
              <a-select-option :value="1">IMAP</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="5">
          <a-form-model-item label="服务器地址" prop="extra.emailSchedule.emailServerAddress"
                             :rules="[
                {
                  required: true,
                  message: '服务器地址不能为空',
                  trigger: 'blur'
                },
                { max: 250, message: '最长不能超过250字符' }
              ]">
            <a-input v-model="addForm.extra.emailSchedule.emailServerAddress" placeholder="请输入" />
          </a-form-model-item>
        </a-col>
        <a-col :span="5"  >
          <a-form-model-item label="端口" prop="extra.emailSchedule.emailServerPort"
                             :rules="
              [
                { required: true, message: '端口不能为空' },
                {
                  pattern:  /^[0-9]\d*$/,
                  message: '端口格式不正确',
                },
              ]"
          >
            <a-input v-model="addForm.extra.emailSchedule.emailServerPort" placeholder="请输入" />
          </a-form-model-item>
        </a-col>
        <a-col :span="3"  style="margin-top: 40px">
          <a-form-model-item prop="extra.emailSchedule.sslState"  class="detection-time">
            <a-checkbox v-model="addForm.extra.emailSchedule.sslState" style="color: #798ba2;">
              使用SSL
            </a-checkbox>
          </a-form-model-item>
        </a-col>
        <a-col :span="5">
          <a-form-model-item label="检测时间" prop="extra.emailSchedule.pollingTime"
                             :rules="[
                {
                  required: true,
                  message: '检测时间不能为空',
                  trigger: 'blur'
                },
              ]"
          >
            <a-input-number
                style="width: 100%"
                v-model="addForm.extra.emailSchedule.pollingTime"
                placeholder="每多少分钟检测一次"
                :min="1"
                :max="999"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="5"   >
          <a-form-model-item label="邮箱账号" prop="extra.emailSchedule.emailUserName"
                             :rules="
                [
                  { required: true, message: '邮箱账号不能为空' },
                  { max: 250, message: '最长不能超过250字符' }
                ]">
            <a-input v-model="addForm.extra.emailSchedule.emailUserName" placeholder="请输入" />
          </a-form-model-item>
        </a-col>
        <a-col :span="5">
          <a-form-model-item label="邮箱密码" prop="extra.emailSchedule.emailPassWord"
                             :rules="
                [
                  { required: true, message: '邮箱密码不能为空' },
                  { max: 250, message: '最长不能超过250字符' }
                ]"
          >
            <a-input-password v-model="addForm.extra.emailSchedule.emailPassWord" placeholder="请输入" />
          </a-form-model-item>
        </a-col>
        <a-col :span="2" style="padding-top:33px ">
          <a-button type="primary" @click="handleOk"  :loading="mailLoad">
            测试邮箱设置
          </a-button>
        </a-col>
        <a-divider orientation="left">
          规则配置
        </a-divider>
        <a-col :span="12"  >
          <a-form-model-item label="收件人地址" class="ant-input-model" prop="extra.emailSchedule.emailReceptAddress"      :rules="
              [
                { max: 800, message: '最长不能超过800字符' }
              ]" >
            <a-input v-model="addForm.extra.emailSchedule.emailReceptAddress" placeholder="可输入多邮箱,以;分割" />
          </a-form-model-item>
        </a-col>
        <a-col :span="5" style="padding-top:39px" >
          <a-form-model-item  prop="extra.emailSchedule.emailReceptAddressType" >
            <a-radio-group v-model="addForm.extra.emailSchedule.emailReceptAddressType" >
              <a-radio :value="0">
                同时包含
              </a-radio>
              <a-radio :value="1">
                任一包含
              </a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>

        <a-col :span="12"   >
          <a-form-model-item label="发件人地址" class="ant-input-model" prop="extra.emailSchedule.emailSendAddress" :rules="
              [
                { max: 800, message: '最长不能超过800字符' }
              ]">
            <a-input v-model="addForm.extra.emailSchedule.emailSendAddress" placeholder="可输入多邮箱,以;分割" />
          </a-form-model-item>
        </a-col>
        <a-col :span="5" style="padding-top:39px" >
          <a-form-model-item  >
            <a-radio-group v-model="emailSendAddressValue" >
              <a-radio :value="0" disabled>
                同时包含
              </a-radio>

            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :span="12"   >
          <a-form-model-item label="邮件标题包含" class="ant-input-model" prop="extra.emailSchedule.emailSubject"  :rules="
              [
                { max: 800, message: '最长不能超过800字符' }
              ]" >
            <a-input v-model="addForm.extra.emailSchedule.emailSubject" placeholder="可输入多关键字,以;分割" />
          </a-form-model-item>
        </a-col>
        <a-col :span="5" style="padding-top:39px" >
          <a-form-model-item  prop="extra.emailSchedule.emailSubjectType" >
            <a-radio-group v-model="addForm.extra.emailSchedule.emailSubjectType" >
              <a-radio :value="0">
                同时包含
              </a-radio>
              <a-radio :value="1">
                任一包含
              </a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :span="12"   >
          <a-form-model-item label="邮件正文包含" class="ant-input-model" prop="extra.emailSchedule.emailContent"  :rules="
              [
                { max: 800, message: '最长不能超过800字符' }
              ]">
            <a-input v-model="addForm.extra.emailSchedule.emailContent" placeholder="可输入多关键字,以;分割" />
          </a-form-model-item>
        </a-col>
        <a-col :span="5" style="padding-top:39px" >
          <a-form-model-item  prop="extra.emailSchedule.emailContentType" >
            <a-radio-group v-model="addForm.extra.emailSchedule.emailContentType" >
              <a-radio :value="0">
                同时包含
              </a-radio>
              <a-radio :value="1">
                任一包含
              </a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :span="12"   >
          <a-form-model-item label="邮件文件夹" class="ant-input-model" prop="extra.emailSchedule.emailFolder"
                             :rules="
              [
                { required: true,  message: '邮件文件夹不能为空' },
                { max: 800, message: '最长不能超过800字符' }
              ]"

          >
            <a-input v-model="addForm.extra.emailSchedule.emailFolder" placeholder="请输入邮件文件夹" />
          </a-form-model-item>
        </a-col>
        <a-divider orientation="left" style="margin-top: 0px">
          触发时间
        </a-divider>
        <a-col
            span="5"
            class="ant-expiry-model"
        >
          <a-form-model-item label="生效时间" prop="startDate">
            <a-date-picker
                v-model="addForm.startDate"
                class="picker-class"
                type="date"
                show-time
                placeholder="选择日期"
                style="width:100%"
                value-format="YYYY-MM-DD HH:mm:00"
                format="YYYY-MM-DD HH:mm"
                :disabled-date="disabledDate"
            />
          </a-form-model-item>
        </a-col>
        <a-col
            span="5"
            class="ant-expiry-model"
        >
          <a-form-model-item label="截止时间" prop="expiryDate">
            <a-date-picker
                style="width: 100%"
                show-time
                type="date"
                v-model="addForm.expiryDate"
                placeholder="选择时间"
                value-format="YYYY-MM-DD HH:mm:00"
                format="YYYY-MM-DD HH:mm"
                :disabled-date="disabledDate"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="5">
          <a-form-model-item label="非工作日限制" prop="calendarId"  class="ant-expiry-model" style="position:relative;">

            <a-select v-model="addForm.calendarId" placeholder="请选择" allowClear>
              <a-select-option
                  :key="item.id"
                  v-for="item in this.workingdayList"
                  :value="item.id"
                  :label="item.name"
              >{{ item.name }}</a-select-option
              >
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>


      <div class="selectionItems">
        <!-- 执行机器人 -->
        <a-row class="time-row" style="margin-top: 20px">
          <header>
            <h3>选择执行设备</h3>
          </header>
          <a-col :span="24">
            <a-tabs default-active-key="1"   class="robotTabs">
              <a-tab-pane key="1" tab="执行设备" >
                <a-col :span="24" >
                  <a-form-model-item
                      prop="executeType"
                      class="group-wrapper"
                      style="margin:5px 0 "
                  >
                    <a-radio-group v-model="addForm.executeType" style="display:flex;justify-content: flex-start;">
                      <a-radio :value="1"> 特定机器人 </a-radio>
                      <a-radio :value="2"> 动态分配 </a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col  :span="12" v-if="addForm.executeType == 2">
                  <a-form-model-item label="执行流程次数" prop="executeCount">
                    <a-input-number
                        placeholder="请输入"
                        style="width: 100%"
                        v-model="addForm.executeCount"
                        :min="1"
                        :max="999"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="24" v-if="addForm.executeType == 1">
                  <a-form-model :model="robotCondition" ref="searchRobotBar"  :layout="formLayout" style="margin: 0px 0 15px;display: flex;justify-content: space-between;">
                    <div>
                      <a-form-model-item prop="searchText">
                        <a-input-search v-model.trim="robotCondition.searchText" placeholder="机器人/计算机"
                                        style="width: 200px; " allow-clear    @input="searchRobotTextChange" @search="robotSearchChange" />
                      </a-form-model-item>
                      <a-form-model-item prop="status">
                        <a-select v-model="robotCondition.status" placeholder="状态" style="width: 180px; "
                                  allowClear @change="robotSearchChange">
                          <a-select-option :value="0">可用</a-select-option>
                          <a-select-option :value="1">断开连接</a-select-option>
                          <a-select-option :value="2">忙碌</a-select-option>
                          <a-select-option :value="3">无响应</a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </div>

                    <a-form-model-item style="float: right;margin-right: 0px;">
                      <a-button icon="redo" @click="resetRobotSearch" size="small" >重 置</a-button>
                    </a-form-model-item>
                  </a-form-model>

                  <a-table
                      :columns="robotColumns"
                      :data-source="robotData"
                      :pagination="robotCondition"
                      @change="robotTableChange"
                      :loading="btnLoad"
                      width="400px"
                      rowKey="id"
                      :rowSelection="{
                        selectedRowKeys: selectedRowKeys,
                        onChange: onSelectChange,
                      }"
                      :scroll="{ y: 200 }"
                      style="margin-bottom:20px;"
                  >
                    <template slot="name" slot-scope="text, record">
                      <img :src="statsIcon[record.status]" />
                      <span> {{ text }}</span>
                    </template>
                    <template slot="status" slot-scope="text">
                      <span> {{ statusName[text] }}</span>
                    </template>
                  </a-table>
                </a-col>
              </a-tab-pane>
              <a-tab-pane key="2" tab="附加参数" force-render>
                <a-col
                    :span="24"
                >
                  <a-table
                      :columns="parameterColumns"
                      :data-source="addForm.parameter"
                      :loading="btnLoad"
                      :pagination="false"
                      :scroll="{ y: 220 }"
                  >
                    <template slot="argName" slot-scope="text, record, index">
                      <span>{{ text }}  <span style="color: red" v-if="record.required == 1">*</span> </span>
                    </template>
                    <template slot="defaultValue" slot-scope="text, record, index">
                      <a-form-model-item :prop="'parameter.' + index + '.defaultValue'"
                                         :rules="{ required: record.required == 1 , message: '请输入参数值', trigger: 'blur' }">
                        <a-input-number
                            v-model="record.defaultValue"
                            placeholder="请输入"
                            :min="1"
                            :max="999"
                            v-if="record.argType === 1"
                            style="width: 100%"
                        />
                        <a-input
                            v-model="record.defaultValue"
                            placeholder="请输入"

                            v-if="record.argType === 2 || record.argType === 4"
                        >
                          <a-icon  slot="suffix" type="edit" style="color: rgba(0,0,0,.45)" />
                        </a-input>
                        <a-select
                            v-model="record.defaultValue"
                            placeholder="请输入"
                            v-if="record.argType === 3"
                        >
                          <a-select-option value="true">是</a-select-option>
                          <a-select-option value="false">否</a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </template>
                  </a-table>
                </a-col>
              </a-tab-pane>
            </a-tabs>
          </a-col>
        </a-row>

        <!-- 通知设置 -->
        <a-row class="time-row" style="margin-top: 20px">
          <header>
            <h3>通知设置</h3>
          </header>
          <a-col :span="24">
            <header style="display: flex;justify-content: space-between;margin-bottom:20px;" >
              <a-button  type="primary" icon="plus" @click="recipientOpen">添加收件人</a-button>
              <a-button class="batchDeletion"  icon="delete"  @click="batchDelete">批量删除</a-button>
            </header>

            <a-table  :data-source="dataSource" :columns="tableColumns"   :rowSelection='rowtriggerSelection' :pagination="false">
              <template slot="action" slot-scope="text, record">
                <a-popconfirm
                    v-if="dataSource.length"
                    title="确定删除收件人吗?"
                    @confirm="() => onDelete(record.id)"
                >
                  <a-icon type="delete" style="color: red;font-size: 16px" />
                </a-popconfirm>
              </template>
            </a-table>

          </a-col>
        </a-row>
      </div>


    </a-form-model>

    <div class="footer">
      <a-button @click="addScheduleCancel"> 取消 </a-button>
      <a-button type="primary" :loading="submitLoad" @click="triggerSubmit">
        确认
      </a-button>
    </div>

    <!--  收件人-->
    <a-modal
        centered
        title="添加收件人"
        :visible="recipientVisible"
        width="600px"
        @ok="recipientSubmit"
        @cancel="resetForm"
        :confirmLoading="submitLoad"
        :maskClosable="false"
    >
      <a-form-model
          :rules="recipientRules"
          :model="recipientForm"
          ref="recipientForm"
      >
        <a-form-model-item label="部门" prop="orgId" key="orgId">
          <a-tree-select
              v-model='recipientForm.orgId'
              allowClear
              @change="orgChange"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              :tree-data="treeData"
              placeholder="选择部门"
              tree-default-expand-all
              :replaceFields="{ title: 'name', key: 'id',value:'id' }"
          >
          </a-tree-select>
        </a-form-model-item>
        <a-form-model-item label="用户" prop="userId" key="userId">
          <a-select
              mode="multiple"
              placeholder="选择用户"
              v-model="recipientForm.userId"
              allow-clear
          >
            <a-select-option
                v-for="v in this.userList"
                :key="v.id"
                :value="v.id"
            >
              {{ v.userName }}
            </a-select-option >

          </a-select>
        </a-form-model-item>

      </a-form-model>

    </a-modal>


  </div>
</template>


<script>
export default {
  computed: {
    rowtriggerSelection() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          this.receivingData = selectedRows
          this.selectedTriggerRowKeys = selectedRowKeys;
        },
        getCheckboxProps: record => ({
          props: {
            disabled:null, // Column configuration not to be checked
          },
        }),
        selectedRowKeys: this.selectedTriggerRowKeys,
      };
    },
  },
  props: [ "processEdit"],
  data() {
    return {
      formLayout:"inline",
      btnLoad: false,
      submitLoad: false,
      mailLoad:false,
      addForm: {
        id: "",
        name: "",
        type: 4,
        processId: undefined,
        priority: 3,
        startDate: this.$moment().add(1,'minute').format('YYYY-MM-DD HH:mm:00'),
        orgId:undefined,
        queueId: undefined,
        expiryDate:'',
        mailId:undefined,
        executeType:1,
        parameter: '',
        robotIds: [],
        executeCount:1,
        calendarId:undefined,
        screenRecord:false,
        versionId:'',
        userIds:'',
        extra:{
          emailSchedule:{
            emailFolder:'INBOX',
            emailServerType:0,
            emailServerAddress:"",
            emailServerPort:'',
            pollingTime:5,
            sslState:false,
            emailUserName:"",
            emailPassWord:"",
            emailReceptAddress:"",
            emailReceptAddressType:0,
            emailSendAddress:'',
            emailSubject:"",
            emailSubjectType:0,
            emailContent:"",
            emailContentType:0,
          }
        }

      },
      // 流程列表
      taskList: [],
      // 非工作日列表
      workingdayList:[],
      // 部门列表
      treeData:[],
      emailSendAddressValue:0,
      addFormRules: {
        name: [
          { required: true,  message: "触发器名称不能为空" },
          { max: 20, message: '最长不能超过20字符' }
        ],
        processId: [{ required: true, message: "流程名称不能为空" }],
        orgId: [{ required: true, message: "部门不能为空" }],
        executeCount: [{ required: true, message: "流程执行次数为空" }],
        priority: [{ required: true, message: "作业优先级不能为空" }],
        emailServerAddress: [{ required: true, message: "服务器地址不能为空" }],
        queueId: [{ required: true, message: "队列名称不能为空" }],
        executeType: [{ required: true, message: "执行设备不能为空" }],
        startDate: [{ required: true, message: "生效时间不能为空" }],
        screenRecord: [{ required: false, message: "是否录屏不能为空" }],
        emailPassWord: [
          { required: true, message: "邮箱密码不能为空" },
          { max: 250, message: '最长不能超过250字符' }
        ],
      }, // 优先级字典
      priorityName: {
        0: "低",
        1: "中",
        2: "高",
        3: "已继承"
      },
      priorityIcon: {
        0: require("../../assets/images/low.png"),
        1: require("../../assets/images/normal.png"),
        2: require("../../assets/images/height.png"),
        3: require("../../assets/images/inherited.png"),
      },
      // 附加参数
      parameterColumns: [
        {
          title: "参数名称",
          dataIndex: "argName",
          key: "argName",
          scopedSlots: { customRender: "argName" },
        },
        {
          title: "参数值",
          dataIndex: "defaultValue",
          key: "defaultValue",
          scopedSlots: { customRender: "defaultValue" },
        },
      ],
      statusName: {
        0: "可用",
        1: "断开连接",
        2: "忙碌",
        3: "无响应",
      },
      statsIcon: {
        0: require("../../assets/images/newest.png"),
        1: require("../../assets/images/break.png"),
        2: require("../../assets/images/beBusy.png"),
      },
      robotData: [],
      robotCondition:{
        searchText: "",
        status:undefined,
        current: 1,
        pageSize: 5,
        pageNo: 1,
        total: 0,
        showQuickJumper: true,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '20', '30', '40', '50'],
        showTotal: (total, range) => `共 ${total} 条记录  `,
        processId: "",
      },
      // 机器人
      robotColumns: [
        {
          title: "机器人",
          dataIndex: "name",
          key: "name",
          scopedSlots: { customRender: "name" },
        },
        {
          title: "计算机",
          dataIndex: "machineName",
          key: "machineName",
        },
        {
          title: "状态",
          dataIndex: "status",
          key: "status",
          scopedSlots: { customRender: "status" },
        },
      ],
      selectedRowKeys: [], //复选框数据
      // 判断流程是否相同
      taskWhether:false,
      // 判断非工作日是否相同
      workWhether:false,
      // 判断是否编辑禁用
      editDisabled:false,
      // 多选
      selectedTriggerRowKeys:[],

      // 通知收件人
      recipientVisible:false,
      receivingData:'',
      recipientForm:{
        orgId:undefined,
        userId:undefined,
      },
      userList:[],
      recipientRules:{
        orgId: [{ required: true, message: "部门不能为空" }],
        userId: [{ required: true, message: "用户不能为空" }],
      },
      dataSource: [],
      count: 2,
      tableColumns: [
        {
          title: '用户名',
          key: "userName",
          dataIndex: 'userName',
          scopedSlots: { customRender: 'userName' },
        },

        {
          title: '邮箱',
          dataIndex: 'email',
          key: "email",
        },
        {
          title: "操作",
          key: "action",
          scopedSlots: { customRender: "action" },
          align: "center",
          width: 60,
        },
      ],

    };
  },
  methods: {
    // 部门筛选
    filter_tree_node( input,node ) {
      if ( node.children == null ) {
        if ( node.componentOptions.propsData.title.indexOf( input ) !=-1 ) {
          return true;
        } else {
          return false;
        }
      }
    },
    // 禁止选择部分日期
    disabledDate(current) {
      return current && current < this.$moment().subtract(1, 'day').endOf('day');
    },
    // 下拉框开启搜索
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },

    // 通知收件人 start
    resetForm(){
      this.recipientVisible = false
      this.recipientForm.orgId = undefined
      this.recipientForm.userId = undefined
      this.userList = []
    },
    recipientOpen(){   // 打开收件人弹出框
      this.recipientVisible = true
    },
    recipientSubmit(){   // 提交收件人
      this.$refs.recipientForm.validate((valid) => {
        if (valid) {
          const { count, dataSource } = this;
          let userData = {};
          this.recipientForm.userId.forEach((b)=>{
            userData = this.userList.find((v)=>{
              return v.id == b
            })
            this.dataSource.push(
                {
                  userName: userData.userName,
                  email: userData.email,
                  id:userData.id
                }
            )
          })
          this.resetForm()
          this.recipientVisible = false

        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    orgChange(val){
      this.userList = []
      this.recipientForm.userId = undefined
      this.axios
          .post("/user/findPage",this.$qs.stringify({pageSize:99999999,orgId:val}))
          .then((res) => {
            if (res.code === 200) {
              this.userList = res.data.records;
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    // 删除
    onDelete(id) {
      const dataSource = [...this.dataSource];
      this.dataSource = dataSource.filter(item => item.id !== id);
    },
    // 批量删除
    batchDelete(){
      const set1 = new Set(this.receivingData);
      const set2 = new Set(this.dataSource);

      set1.forEach((value) => {
        // 如果有重复元素则从第二个数组中删除该元素
        if (set2.has(value)) {
          set2.delete(value);
        }
      });

      const resultArr = Array.from(set2);
      this.dataSource = resultArr
      this.selectedTriggerRowKeys = []
    },

    // 通知收件人 end


    // switch开关转换
    switchChange(val){
      if (val){
        this.addForm.screenRecord = 1
      }else{
        this.addForm.screenRecord = 0
      }
    },
    // 监听流程下拉框-选择机器人
    taskChange(val) {
      let obj = this.taskList.find((item) => {
        return item.id === val;
      });
      this.robotTableChange('','','',obj.id)
      // 附加参数
      this.parameterList( obj.versionId,obj.id)
      this.addForm.versionId = obj.versionId
      this.addForm.robotIds = undefined;
      this.selectedRowKeys = []
    },
    // 取消添加排班
    addScheduleCancel() {
      this.$emit("closeConfig");
    },
    triggerSubmit() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.submitLoad = true;
          let saveTriggerData = this.$lodash.cloneDeep(this.addForm);
          saveTriggerData.parameter = saveTriggerData.parameter
            ? JSON.stringify(saveTriggerData.parameter)
            : [];
          if (this.processEdit) {
            saveTriggerData.robotIds = this.selectedRowKeys.length > 0 ? this.selectedRowKeys.join(',') : ""
          }else{
            saveTriggerData.robotIds = saveTriggerData.robotIds ? saveTriggerData.robotIds.join(",") : '';
          }
          if (saveTriggerData.screenRecord ){
            saveTriggerData.screenRecord = 1
          }else{
            saveTriggerData.screenRecord = 0
          }
          // 循环取收件人用户id
          let ids = []
          this.dataSource.forEach((item)=>{
            ids.push(item.id)
          })
          saveTriggerData.userIds = ids ? ids.join(",") : '';
          this.axios
            .post(this.saveApi, saveTriggerData)
            .then((res) => {
              this.submitLoad = false;
              if (res.code === 200) {
                this.$message.success(res.message);
                this.$emit("closeConfig");
              }
            })
            .catch((err) => {
              this.submitLoad = false;
              console.log(err);
            });
        }else{
          this.$message.warning('请检查必填项(含附加参数)是否全部填写完成');
        }
      });
    },

    // 监听部门
    treeChange(val){
      // 请求流程下拉框接口
      this.addForm.processId = undefined
      this.addForm.calendarId = undefined
      this.addForm.queueId = undefined
      this.addForm.parameter = ''
      this.axios
        .post("/process/findProcess",{orgId:val})
        .then((res) => {
          // console.log(res.data);
          if (res.code === 200) {
            this.taskList = res.data;
            if (!this.processEdit.processId) {
                return   this.taskWhether = false
            }
            let obj = this.taskList.find((item) => {
              return item.id === this.processEdit.processId;
            });
            if (obj) {
              this.taskWhether = false
            }else{
              this.taskWhether = true
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
        this.allkingdayList(val)
    },
    // 部门下拉框
    allorgList() {
      this.axios
        .post("/org/findOrg",'')
        .then((res) => {
          if (res.code === 200) {
            this.treeData = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 测试发送
    handleOk() {
      this.mailLoad = true
      this.axios
        .post("/schedule/sendEmail",
          {
            emailReceptAddress:this.addForm.extra.emailSchedule.emailReceptAddress,
            emailServerAddress:this.addForm.extra.emailSchedule.emailServerAddress,
            emailUserName:this.addForm.extra.emailSchedule.emailUserName,
            emailPassWord:this.addForm.extra.emailSchedule.emailPassWord,
            emailServerType:this.addForm.extra.emailSchedule.emailServerType,
            emailServerPort:this.addForm.extra.emailSchedule.emailServerPort,
            sslState:this.addForm.extra.emailSchedule.sslState,
            emailFolder:this.addForm.extra.emailSchedule.emailFolder,
          }
        )
        .then((res) => {
          this.mailLoad = false
          if (res.code === 200) {
            this.$message.success(res.message);
          }
        })
        .catch((err) => {
          this.mailLoad = false
          console.log(err);
        });
    },
    // 监听表格复选
    onSelectChange(selectedRowKeys, selectedRows) {
      let obj = [];
      selectedRows.forEach((element) => {
        obj.push(element.id);
      });
      this.addForm.robotIds = obj;
      this.selectedRowKeys = selectedRowKeys;
    },
    // 非工作日列表
    allkingdayList(id){
      this.axios
        .post("calendar/findCalendar", {orgId:id})
        .then((res) => {
          if (res.code === 200) {
            this.workingdayList = res.data;
            if (!this.processEdit.calendarId) {
                return   this.workWhether = false
            }
            let obj = this.workingdayList.find((item) => {
              return item.id === this.processEdit.calendarId;
            });
            if (obj) {
              this.workWhether = false
            }else{
              this.workWhether = true
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 附加参数
    parameterList(versionId,id){
      this.axios
        .post(
          "/process/findProcessArgsByProcess",
          "versionId=" + versionId + "&processId=" + id
        )
        .then((res) => {
          if (res.code === 200) {
            this.addForm.parameter = res.data;
            for (let i = 0; i < this.addForm.parameter.length; i++) {
              if (this.addForm.parameter[i].defaultValue) {
                this.addForm.parameter[i].defaultValue = undefined;
              }else{
                this.addForm.parameter[i].defaultValue = undefined;
              }
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 重置搜索
    resetRobotSearch() {
      this.$refs.searchRobotBar.resetFields()
      this.robotCondition.current = 1
      this.robotCondition.pageNo = 1
      this.robotSearchChange()
    },
    searchRobotTextChange(val) {
      if (window.searchTimer) {
        clearTimeout(searchTimer);
      }
      window.searchTimer = setTimeout(() => {
        this.robotSearchChange(val)
      }, 1200);
    },

    // 搜索
    robotSearchChange(v) {
      this.robotCondition = this.$lodash.cloneDeep(this.robotCondition)
      this.robotCondition.processId = this.addForm.processId
      this.allRobotList()
    },
    // 监听分配机器表格翻页
    robotTableChange(pagination, filters, sorter) {
      this.robotCondition.pageNo = pagination.current ? pagination.current : 1
      this.robotCondition.current = pagination.current ? pagination.current : 1
      this.robotCondition.pageSize = pagination.pageSize ? pagination.pageSize : 5

      this.selectedRowKeys = []
      this.addForm.robotIds = undefined;
      this.allRobotList()
    },

    // 特定机器人列表
    allRobotList(id) {
      this.robotCondition.processId = this.addForm.processId
      this.axios
        .post(
          "/robot/findRobotsByProcessId",
            this.robotCondition
        )
        .then((res) => {
          // console.log(res.data);
          if (res.code === 200) {
            this.robotData = res.data.records;
            this.robotCondition.total = res.data.total;

            this.selectedRowKeys = this.processEdit.robotIds
                ? this.processEdit.robotIds.split(",")
                : [];
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  beforeMount() {
    this.allorgList();
    this.saveApi = "/schedule/save";
    if (this.processEdit) {
      this.editDisabled = true
      this.treeChange(this.processEdit.orgId )
      this.addForm.orgId = this.processEdit.orgId
      this.saveApi = "/schedule/update";
      this.addForm = this.$lodash.pick(
        this.processEdit,
        this.$lodash.keys(this.addForm)
      );
      if(this.addForm.executeType == 1){
        // this.robotTableChange('','','',this.addForm.processId)
        this.robotSearchChange()
      }
      //  请求收件人接口循环取值
      this.axios
          .post("/user/findScheduleUsers",{id:this.processEdit.id})
          .then((res) => {
            if (res.code === 200) {
              res.data.forEach((item)=>{
                console.log(item)
                this.dataSource.push({
                  userName: item.userName,
                  email: item.email,
                  id:item.id
                })
              })
            }
          })
          .catch((err) => {
            console.log(err);
          });
      // this.parameterList(this.processEdit.versionId,this.processEdit.processId)
      this.addForm.calendarId = this.addForm.calendarId ?  this.addForm.calendarId: undefined
      this.addForm.parameter = this.processEdit.objParams ? this.processEdit.objParams : []
          this.selectedRowKeys = this.addForm.robotIds
        ? this.addForm.robotIds.split(",")
        : [];
    }else{
      this.treeChange(this.addForm.orgId )
    }
  },
};
</script>

<style lang="scss" scoped>
.selectionItems{
  display: flex;
  width: 100%;
  .time-row{
    width: 49.5%;
  }
  .time-row:nth-child(1){
    margin-right: 15px;
  }
}
.batchDeletion{
  margin-left:15px;
  ::v-deep.ant-btn{
    .anticon-delete{
      color: red;
    }
  }
}
.ant-form{
  position: relative;
  max-height: calc(100vh - 210px);
  overflow: auto;
  ::v-deep .ant-form-item label{
    font-weight: normal;
    color: #576d8a;
  }

  .time-row{
    background-color: #ffffff;
    padding: 0px 25px;
    header{
      margin-top: 15px;

      h3{
        font-weight:bold;
        margin-bottom: 3px;
      }
    }
    .ant-divider{
      text-align: left;
    }
    .ant-divider-horizontal.ant-divider-with-text-left::before{
      width: 0%;
    }
    .ant-divider-horizontal.ant-divider-with-text-left::after{
      width: 96%;
    }
    ::v-deep .ant-divider-inner-text{
      padding: 0px;
      font-size: 14px;
      font-weight: bold;
    }
    .ant-col{
      margin-right: 0.7%;
      .group-wrapper{
        .ant-radio-button-wrapper{
          margin-right: 20px;
          border-radius: 4px;
          background: #f0f5fb;
          border:0px ;
        }
        .ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled){
          background: #3471fa;
          color: #fff;
        }
        .ant-radio-button-wrapper:not(:first-child)::before{
          background-color: transparent;
        }
      }
      .ant-checkbox-group{
        .ant-checkbox-wrapper + .ant-checkbox-wrapper{
          margin:0 0 20px 25px;
        }
      }
    }

    .ant-col-5{
      width: 24.3%;
    }
  }

}


// switch样式
.ant-switch-model {
  display: flex;
  .ant-switch {
    height: 15px;
    min-width: 36px;
  }
  .ant-switch-checked::after {
    background-color: #3471fa;
    margin-left: 1px;
    left: 100% !important;
  }
  .ant-switch-checked {
    background-color: #83a2e7;
  }
  .ant-switch-loading-icon,
  .ant-switch::after {
    top: -3px;
    width: 19px;
    height: 19px;
    left: -1px;
  }
  p {
    line-height: 19px;
    margin-left: 10px;
    color: #8192a7;
  }
}
// 表单样式
.footer {
  position: absolute;
  top: -50px;
  right: 25px;
  z-index: 99;
  display: flex;
  justify-content: flex-end;
  .ant-btn {
    padding: 0 20px;
  }
  .ant-btn:nth-child(1) {
    margin-right: 10px;
  }
}

// tab样式
.robotTabs{
  padding-top:20px;
  ::v-deep .ant-tabs-nav{
    width: 94%;
    .ant-tabs-tab{
      width: 48%;
      text-align: center;
      font-weight: 600;
    }
  }
  ::v-deep  .ant-tabs-tab-active{
    background-color: #fafafa;
    color: #3c65f5 !important;
  }
}


.margin-15{
  margin-right: 15px;
}
::v-deep .ant-table-header{
  margin-right: -10px;
}
::v-deep .ant-table-row td{
  padding: 10px 16px;
  .ant-form-item{
    //width: 378px;
    margin-bottom: 0px;
  }
}
.ant-col-12{
  width: 49.4%;
}
.group-wrapper{
  margin-bottom: 32px;
  ::v-deep .ant-form-item-control-wrapper{
    padding-top:4px;
  }
}
.picker-wrapper{

  ::v-deep .ant-time-picker{
    padding-top: 2px;
  }
}


.runCronTop5{
  border:1px solid #dde2e8;
  border-radius:4px;
  padding:15px 20px 5px;
  p{
    font-weight:900;
    font-size:14px;
    margin-bottom:20px;
  }
  .ant-timeline-item{
    padding-bottom:10px;
  }
  ::v-deep .ant-timeline-item-last > .ant-timeline-item-content{
    min-height:0px;
  }
}

/* 垂直滚动条样式 */
/* 宽度 */
::-webkit-scrollbar {
  width: 5px;

}
/* 背景色 */
::-webkit-scrollbar-track {
  background-color: #ffff;
}
/* 滑块颜色 */
::-webkit-scrollbar-thumb {
  background-color: #d7dde4;
}

/* 水平滚动条样式 */
/* 高度 */
::-webkit-scrollbar {
  height: 5px;
}
/* 背景色 */
::-webkit-scrollbar-track {
  background-color: #ffff;
}
/* 滑块颜色 */
::-webkit-scrollbar-thumb {
  background-color: #d7dde4 ;
}
</style>